import type { UsersRequestsDto, UserRequestsRowDto } from './dto';
import type { UserRequestsRow, UsersRequestsResult } from './types';

function str(value: string | null | undefined): string | null {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === 'None') return null;
    return trimmed;
}

function toRow(dto: UserRequestsRowDto, index: number): UserRequestsRow {
    return {
        /* Отдельного id у строки может не быть — тогда ключом служит имя,
           а на крайний случай позиция в списке. */
        id: str(dto.user_id) ?? str(dto.full_name) ?? `row-${index}`,
        fullName: str(dto.full_name) ?? '—',
        totalCount: dto.total_count ?? 0,
        projectsCount: dto.count_projects ?? 0,
        organization: str(dto.organization) ?? '—',
    };
}

export function toUsersRequests(dto: UsersRequestsDto): UsersRequestsResult {
    return {
        rows: Array.isArray(dto?.data) ? dto.data.map(toRow) : [],
        summary: {
            users: dto?.count_users ?? 0,
            activeUsers: dto?.active_users ?? 0,
            products: dto?.total_product_count ?? 0,
            projects: dto?.total_project_count ?? 0,
            requests: dto?.total_requests_count ?? 0,
        },
    };
}